import React from "react"
import { parkingState } from "../../zustand/parkingState"
import config from "react-global-configuration"

const RefundGuarantee = ({ textKeys: propsTextKeys, modifier }) => {
  const openModal = () => {
    const textKeys = propsTextKeys || config.get("textKeys.refundGuarantee") || {}
    if (!textKeys) return
    const { refundGuaranteeModalHeadline, refundGuaranteeModalText } = textKeys
    const data = {
      refundGuaranteeModalOpen: true,
      refundGuaranteeModalData: {
        h3: refundGuaranteeModalHeadline,
        richText: refundGuaranteeModalText,
      },
    }
    parkingState.setState(data)
    if (parkingState.getState().trackingFunction) parkingState.getState().trackingFunction()
  }

  const textKeys = config.get("textKeys.refundGuarantee") || {}
  if (!textKeys || !textKeys.refundGuaranteeText) return null

  return (
    <div className={`deck deck--white ${parkingState.getState().useNewDesign ? "deck--padding-bottom-slim" : "deck--padding-bottom"}`}>
      <div className="w--wider">
        <div
          className={`refund-guarantee refund-guarantee--block ${parkingState.getState().modifier ? parkingState.getState().modifier : ""} ${
            parkingState.getState().useNewDesign ? "refund-guarantee--new" : ""
          }`}
        >
          {/* eslint-disable react/no-unknown-property */}
          {textKeys.refundGuaranteeImage ? (
            <img
              aria-hidden="true"
              tabIndex={-1}
              alt=""
              className="refund-image"
              src={textKeys.refundGuaranteeImage}
              loading="eager"
              fetchpriority="high"
            />
          ) : (
            ""
          )}
          {/* eslint-enable react/no-unknown-property */}

          <span className="refund-text" dangerouslySetInnerHTML={{ __html: textKeys.refundGuaranteeText }}></span>
          {textKeys.refundGuaranteeLinkText ? (
            <button
              aria-label={textKeys.refundGuaranteeLinkText}
              className="modal-link"
              onClick={openModal}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  openModal()
                }
              }}
              tabIndex={0}
            >
              {textKeys.refundGuaranteeLinkText}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  )
}

export default RefundGuarantee
